import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import ReportWidget from '@/shared/cards/briefing/resource/report-widget/report-widget.vue';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import { convertToBriefingResourceReq, isOutOfDateMakeAThon } from '@/util/ds-util';
import GroupCardV2 from '@/shared/cards/briefing/resource/group-card/group-card-v2.vue';
import GoCardCompanyVer2 from '@/shared/cards/company/go-company-card.vue';
import TopicWidget from '@/shared/cards/briefing/resource/topic-card/topic-widget.vue';
import { TIME_CHECK_LOADING_REPORT } from '@/constants';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';
import DiscoveryWidget from '@/shared/cards/briefing/resource/discovery-widget/discovery-widget.vue';
import VideoWidget from '@/shared/cards/briefing/resource/video-widget/video-widget.vue';
import LoadingReportCardUtil from '@/util/loading-report-card.util';
import ReportToastUtil from '@/util/report-toast.util';
import MakerthonCard from '@/shared/cards/makerthon/makerthon-card.vue';
import UserMyPageService from '@/service/userMyPage.service';
import { checkIsGuestAccount } from '@/util/guest-util';
import ChatHistoryCard from '@/shared/cards/my-create/ask-goover/chat-history-widget.vue';
import { formatDateAgo } from '@/util/date-util';
import moment from 'moment';
import { ConversationInfo } from '@/shared/model/ask-goover.model';
import AskGooverService from '@/service/ask-goover.service';
import ChatHistoryModalComponent from '@/shared/cards/my-create/ask-goover/chat-history-modal.vue';
import { v4 as uuidv4 } from 'uuid';
import ScrapAgentService from '@/service/scrap-agent.service';
import axios from 'axios';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

@Component({
  computed: {
    moment() {
      return moment;
    },
  },
  methods: { formatDateAgo },
  components: {
    'discovery-card': DiscoveryWidget,
    'report-card': ReportWidget,
    'video-card': VideoWidget,
    'group-card-v2': GroupCardV2,
    'company-card-v2': GoCardCompanyVer2,
    'topic-card': TopicWidget,
    'list-loading': ListLoading,
    'makerthon-card': MakerthonCard,
    'chat-history-card': ChatHistoryCard,
    'chat-history-modal': ChatHistoryModalComponent,
  },
  mixins: [ReportToastUtil],
})
export default class ResourceGridView extends Vue {
  @Prop(Array) readonly resourceItems: any[] | [];
  @Prop(Boolean) readonly loadMoreAble: boolean;
  @Prop(Boolean) readonly isHiddenRemove: boolean;
  @Prop({ type: Boolean, default: false }) readonly isDisabledRemoveLoading!: boolean;
  @Prop(Boolean) readonly isAddingMoreData: boolean | false;
  @Prop(Boolean) readonly isLoadingResource: boolean | false;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean | false;
  @Prop({ type: Boolean, default: true }) readonly isShowCardEvent!: boolean;
  @Prop(Array) readonly reportLoadingCardInHeaderList?: IResourceModel[] | [];
  @Prop(Boolean) readonly isFromBriefingDetail: boolean | false;
  @briefingStore.Getter
  public getUpdateResources!: IResourceModel;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @Inject('askGooverService')
  private askGooverService!: () => AskGooverService;

  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;
  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;
  @briefingStore.Mutation
  public updateAddingResources!: (payload: IResourceModel) => void;
  @briefingStore.Mutation
  public updateTotalResources!: (payload: number) => void;
  @briefingStore.Getter
  getReferenceDocuments!: Array<any>;
  @briefingStore.Mutation
  public addToReferentDocuments!: (docIds: any[]) => void;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @briefingStore.Action
  public removeFromReferenDocuments!: (payload: any) => void;

  @briefingStore.Getter
  public getIsHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Getter
  public getIsDoneHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsDoneHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Mutation
  public setSelectedHideResource!: (payload: any) => void;

  @appStoreState.Getter
  public getReShowToastReport!: boolean;

  @appStoreState.Mutation
  public setReShowToastReport!: (payload: boolean) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStore.Mutation
  public setIsCreateNewBriefingFromChat!: (IsCreateNewBriefingFromChat: boolean) => void;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (isCanShowCreateAgent: boolean) => void;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @briefingStore.Getter
  public getReloadAfterEditedReport!: boolean;

  @briefingStore.Getter
  public getIsSearchingBriefingAgent!: boolean;

  loadingReportCardUtil = new LoadingReportCardUtil();
  reportToastUtil = new ReportToastUtil();

  isFromFooter = false;
  isFromDetail = false;
  tempDeleteObject: any = {};
  isLoading = false;
  countTimesOnchange = 0;
  intervalCheckToRemoveOverTimeLoadingReportCard;
  isDueDateMakeAThon = false;
  intervalRemoveLoadingReportData;
  currentConversation = {};
  historyOpenModal = false;
  tempUser = JSON.parse(localStorage.getItem('localStorageUser')) || {};
  scrapAgentService = new ScrapAgentService();
  language: string = this.$i18n.locale || localStorage.getItem('currentLanguage');

  @Watch('getReloadAfterEditedReport')
  async onGetReloadAfterEditedReportChange(newVal: any) {
    if (newVal) {
      this.$emit('refresh');
    }
  }

  private showToast(message: string, title: string, variant = 'info'): void {
    this.$bvToast.toast(message, {
      title: title,
      variant: variant,
      solid: true,
      autoHideDelay: 5000,
      toaster: 'b-toaster-bottom-right',
      noCloseButton: false,
      appendToast: true,
    });
  }

  mounted() {
    $('#container-block').on('scroll', this.infinityScroll);
    this.isFromFooter = false;
    this.isFromDetail = false;
    this.tempDeleteObject = {};
    this.isLoading = false;
    this.handleClearCheckToRemoveOverTimeLoadingReportCardInterval();
    // if (!this.isDisabledRemoveLoading) {
    // }
    this.handleRemoveLoadingReportData();
    this.checkToRemoveOverTimeLoadingReportCard();
    this.handleRemoveAllDuplicatedItem();
    this.isDueDateMakeAThon = isOutOfDateMakeAThon();
  }

  deactivated() {
    this.historyOpenModal = false;
  }

  beforeDestroy() {
    this.handleClearCheckToRemoveOverTimeLoadingReportCardInterval();
  }

  share(item: IResourceModel) {
    console.log('share', item);
  }

  @Emit('load-more') loadMore() {}

  @Watch('getIsHideSelectedResourceItem')
  onGetIsHideSelectedResourceItemChange() {
    if (
      this.getIsHideSelectedResourceItem === true &&
      this.getSelectedResource &&
      this.getSelectedResource._id &&
      this.getSelectedResource.docId &&
      this.resourceItems &&
      this.resourceItems.length > 0 &&
      (this.isFromFooter === false || this.isFromFooter === undefined) &&
      !this.checkDuplicatedDelete(this.getSelectedResource) &&
      this.isLoading === false &&
      this.countTimesOnchange === 0
    ) {
      const tempResource: any = this.resourceItems;

      let tempIndex = tempResource.findIndex(i => i._id === this.getSelectedResource._id && i.docId === this.getSelectedResource.docId);

      if (tempIndex === -1) {
        tempIndex = tempResource.findIndex(i => i._id === this.getSelectedResource._id || i.docId === this.getSelectedResource.docId);
      }

      try {
        if (tempIndex !== -1) {
          ++this.countTimesOnchange;
          this.hide(this.getSelectedResource, tempIndex, 'fromDetail');
        } else {
          if (this.$route.name !== 'Home') {
            this.setSelectedHideResource(this.getSelectedResource);

            if (this.getIsDoneHideSelectedResourceItem === false) {
              this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
            } else {
              this.setIsDoneHideSelectedResourceItem(true);
            }
          }
        }
      } catch (e) {
        this.setIsHideSelectedResourceItem(false);
      }
    }
  }

  @Watch('resourceItems')
  onResourceItemsChange() {
    // if (!this.isDisabledRemoveLoading) {
    // }
    this.handleRemoveLoadingReportData();
    this.handleRemoveAllDuplicatedItem();
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  // listen change from report detail
  @Watch('getUpdateResources')
  public onChangeSelectedResource(item) {
    const foundIdx = this.resourceItems.findIndex(data => data._id === item._id);
    Vue.set(this.resourceItems[foundIdx], 'isBookmarked', item.isBookmarked);
    // this.toggle2Resource(item, foundIdx);
  }

  get filteredReportCards() {
    const target = ['REPORT', 'JOURNALIST_NOTE', 'SOCIAL_MEDIA'];
    return (this.reportLoadingCardInHeaderList || []).filter(
      item => item && target.includes(item.type) && item.requestId && item.isLoadingCard
    );
  }

  @Emit('hide')
  hide(item: IResourceModel, index: number, fromWhere?: string) {
    if (checkIsGuestAccount(true)) {
      return;
    }

    if (
      (this.isFromFooter === true && fromWhere && fromWhere === 'fromFooter') ||
      (this.isFromDetail === true && fromWhere && fromWhere === 'fromDetail')
    ) {
      return;
    }

    this.isFromFooter = fromWhere && fromWhere === 'fromFooter' ? true : false;
    this.isFromDetail = fromWhere && fromWhere === 'fromDetail' ? true : false;

    if (item) {
      switch (item.originParentDocDetail?.doc_type) {
        case 1:
          item.type = 'REFERENCE';
          break;
        case 2:
          item.type = 'DISCOVERY';
          break;
        case 3:
          item.type = 'RESOURCE';
          break;
        case 4:
          item.type = 'REPORT';
          break;
        case 5:
          item.type = 'ASK_GOOVER';
          break;
        case 6:
          item.type = 'PEOPLE';
          break;
        case 7:
          item.type = 'COMPANY';
          break;
        case 8:
          item.type = 'TOPIC_SUMMARY';
          break;
        default:
          break;
      }
    } else {
      this.isLoading = false;
      return;
    }

    if (!item.type) {
      this.isLoading = false;
      return;
    }

    if (this.$route.name !== 'Home') {
      this.setSelectedHideResource(item);
    }

    if (item.type !== 'REFERENCE') {
      if (this.$route.name !== 'Home') {
        if (!this.checkDuplicatedDelete(item)) {
          this.tempDeleteObject = { id: item._id ? item._id : '', docId: item.docId ? item.docId : '' };
          this.isLoading = true;

          this.briefingService()
            .feedUpdateStatus({
              id: item._id ? item._id : '',
              briefingPageId: item.bpId
                ? item.bpId
                : item.originParentDocDetail?.briefing_page_id
                ? item.originParentDocDetail.briefing_page_id[0]
                : '',
              parentDocId: item.docId ? item.docId : '',
              typeDocument: item.type ? item.type : '',
              isDeleted: true,
            })
            .then(response => {
              if (response?.data?.body?.body && response?.data?.body?.status === 1 && response?.data?.body?.success === true) {
                if (index !== -1) {
                  this.resourceItems.splice(index, 1);
                }

                if (this.getIsDoneHideSelectedResourceItem === false) {
                  this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
                } else {
                  this.setIsDoneHideSelectedResourceItem(true);
                }

                // @ts-ignore
                this.setSelectedResource({});
                this.setShowDetailArticles(false);
                this.setShowDetailReport(false);
                this.setShowDetailTopic(false);
              } else {
                this.tempDeleteObject = {};
              }
            })
            .catch(e => {
              this.setIsHideSelectedResourceItem(false);
              this.tempDeleteObject = {};
            })
            .finally(() => {
              setTimeout(() => {
                this.setIsHideSelectedResourceItem(false);
                this.isLoading = false;
                this.isFromFooter = false;
                this.isFromDetail = false;
                this.countTimesOnchange = 0;
              }, 10);
            });
        }
      } else {
        if (!this.checkDuplicatedDelete(item)) {
          this.tempDeleteObject = { id: item._id ? item._id : '', docId: item.docId ? item.docId : '' };
          this.isLoading = true;

          if (item.isNew) {
            // Hide in view (not call api)
            this.resourceItems.splice(index, 1);
            return;
          }

          this.briefingService()
            .callAPIHideCardInHome({
              id: item._id ? item._id : '',
              similar_hash: item.originParentDocDetail?.similar_hash ? item.originParentDocDetail?.similar_hash : '',
              userKey:
                this.userIdentity?.id || this.$store.getters?.account?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '',
              briefingPageId: item.bpId
                ? item.bpId
                : item.originParentDocDetail?.briefing_page_id
                ? item.originParentDocDetail.briefing_page_id[0]
                : '',
              parentDocId: item.docId ? item.docId : '',
              isLiked: true,
              isBookmarked: item.isBookmarked ? true : false,
              isDeleted: true,
              typeDocument: item.type ? item.type : '',
            })
            .then(response => {
              if (response?.data?.body?.body && response?.data?.body?.status === 1 && response?.data?.body?.success === true) {
                if (index !== -1) {
                  this.resourceItems.splice(index, 1);
                }

                if (this.getIsDoneHideSelectedResourceItem === false) {
                  this.setIsDoneHideSelectedResourceItem(!this.getIsDoneHideSelectedResourceItem);
                } else {
                  this.setIsDoneHideSelectedResourceItem(true);
                }

                // @ts-ignore
                this.setSelectedResource({});
                this.setShowDetailArticles(false);
                this.setShowDetailReport(false);
                this.setShowDetailTopic(false);
              } else {
                this.tempDeleteObject = {};
              }
            })
            .catch(e => {
              this.setIsHideSelectedResourceItem(false);
              this.tempDeleteObject = {};
            })
            .finally(() => {
              setTimeout(() => {
                this.setIsHideSelectedResourceItem(false);
                this.isLoading = false;
                this.isFromFooter = false;
                this.isFromDetail = false;
                this.countTimesOnchange = 0;
              }, 10);
            });
        }
      }
    }
  }

  async bookMarkReport(item: IResourceModel) {
    try {
      const userKey = item.owner_user_key || this.$store.getters?.userIdentity?.id;
      const requestId = uuidv4();
      const { title, url: path, content, type, userProfile, originParentDocDetail, bpId, publishAt, owner_user_key, _id, writer } = item;

      const requestBody = [
        {
          requestId,
          title,
          path,
          description: content,
          content,
          type,
          collector: 'UW',
          userKey: userKey,
          originDate: originParentDocDetail.created_at,
          searchTypes: originParentDocDetail.search_type,
          mediaType: originParentDocDetail.media_type,
          imageUri: [],
          imageUriThumbnail: originParentDocDetail.image_uri_thumbnail,
          collectedQuality: originParentDocDetail.collected_quality,
          favicon: '',
          img: '',
          lang: '',
          liked: 0,
          keyword: '',
          getMlEntity: [],
          getMlEntitySearch: [],
          requestBy: userKey,
          parentDocId: originParentDocDetail.parent_doc_id[0],
          parentDocIds: originParentDocDetail.parent_doc_id,
          forcedClustering: false,
          requestedResourceList: originParentDocDetail.parent_doc_id,
          targetBpId: null,
          titleBriefingPage: '',
          isFeed: true,
          htmlRaw: '',
          publishedAt: publishAt,
          serviceHtml: '',
          ownerUserKey: owner_user_key || userKey,
          sameBriefingPage: false,
          docType: 11,
          isInsideGroup: false,
          isGroup: false,
          originType: 'REPORT',
          otherInfo: null,
          chunkId: '',
          chunkText: '',
          _id: null,
          created_at: originParentDocDetail.created_at,
          writer: [writer],
          author: writer,
          searchType: originParentDocDetail.search_type[0],
          isBookmarked: true,
        },
      ];

      await this.scrapAgentService.saveDefaultScrapAgentByType(userKey, requestBody);
    } catch (error) {
      console.error('Error bookmarking report:', error);
    }
  }

  async unBookMarkReport(item: IResourceModel) {
    try {
      const payload = {
        id: item.originParentDocDetail._id,
        briefingPageId: item.bpId,
        parentDocId: item.originParentDocDetail.parent_doc_id[0],
        isBookmarked: false,
        isDeleted: false,
        typeDocument: item.documentType || 'SCRAPE',
      };
      await this.briefingService().feedUpdateStatus(payload);
    } catch (error) {
      console.error('Error unbookmarking report:', error);
    }
  }

  async toggle2Resource(item: IResourceModel, index: number) {
    if (checkIsGuestAccount(true)) return;

    Vue.set(this.resourceItems[index], 'updatingBookmark', true);
    const toggleBookmark = !item.isBookmarked;

    try {
      if (toggleBookmark) {
        await this.bookMarkReport(item);
      } else {
        await this.unBookMarkReport(item);
      }

      Vue.set(this.resourceItems[index], 'isBookmarked', toggleBookmark);
      if (this.isHiddenRemove && !toggleBookmark) {
        this.resourceItems.splice(index, 1);
      }

      const updatedResource = {
        ...item,
        updatingBookmark: false,
        isBookmarked: toggleBookmark,
      };

      const isOwnerResourceItem = item.owner_user_key === this.$store.getters?.userIdentity?.id;
      if (isOwnerResourceItem) {
        updatedResource.userProfile = {
          userKey: item.owner_user_key || this.$store.getters?.userIdentity?.id,
          lastName: item.userProfile?.lastName || this.$store.getters?.userIdentity?.lastName,
          imageUrl: item.userProfile?.imageUrl || this.$store.getters?.userIdentity?.imageUrl,
        };
      }

      this.updateAddingResources(updatedResource);
      this.updateTotalResources(toggleBookmark ? 1 : -1);
    } catch (error) {
      console.error('Error toggling bookmark:', error);
    } finally {
      Vue.set(this.resourceItems[index], 'updatingBookmark', false);
    }
  }

  viewDetail(item: IResourceModel) {
    this.setSelectedResource(item);
    const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
    const mediaType = item?.originParentDocDetail?.media_type[0];
    if (!mediaType) {
      return;
    }

    const mediaTypeBelongGoover = ['REPORT', 'TOPIC_SUMMARY', 'COMPANY', 'CHAT_HISTORY'];
    if (!mediaTypeBelongGoover.includes(mediaType)) {
      window.open(item?.originParentDocDetail?.source_uri, '_blank');
      return;
    }

    if (mediaType == 'REPORT') {
      this.setShowDetailReport(true);
      this.userMyPageService().saveUserActivitiesOpenReportDetail(item.docId, language);
      return;
    }

    if (mediaType == 'TOPIC_SUMMARY') {
      this.setShowDetailTopic(true);
      return;
    }

    this.setShowDetailArticles(true);
  }

  onSelectUserSocial(agentKey: string) {
    const userKey = this.$store.getters?.userIdentity?.id;
    if (userKey === agentKey) {
      this.$router.push('/my-briefing');
    } else {
      this.$router.push(`/social-user/${agentKey}`);
    }
  }

  infinityScroll() {
    if (this.getIsSearchingBriefingAgent) {
      return;
    }
    const container = $('#container-block').get(0);
    const scrollY = container.scrollHeight - container.scrollTop;
    const height = container.offsetHeight;
    const offset = height - scrollY;
    if (this.loadMoreAble && -2000 < offset) {
      this.loadMore();
    }
  }

  addToReference(document: IResourceModel) {
    if (checkIsGuestAccount(true)) return;
    let isUpdateBriefing = false;
    if (this.$route.name === 'Home') {
      document.requestedResourceList = [document.docId];
      isUpdateBriefing = false;
    } else {
      document.requestedResourceList = [
        document.docId,
        ...this.getReferenceDocuments.map(document => document.docId || document.parentDocId),
      ];
      isUpdateBriefing = true;
    }
    const briefingResource = this.convert2ReferenceResource(document, isUpdateBriefing);

    this.briefingService()
      .saveBriefingResource([briefingResource], true)
      .then(() => {
        briefingResource.published_at = document.publishAt;
        briefingResource.originParentDocDetail = document.originParentDocDetail;
        briefingResource.docId = document.docId;
        briefingResource.isNew = true;
        this.addToReferentDocuments([briefingResource]);
      })
      .catch(err => {
        this.removeFromReferenDocuments({ docIdsToRemove: [briefingResource.parentDocId || briefingResource.parent_doc_id] });
      });
  }

  addToNewAgentBriefing(document: IResourceModel) {
    if (checkIsGuestAccount(true)) return;
    const briefingResource = this.convert2ReferenceResource(document, false, 1);
    this.setReferenceDocumentsForNewBriefing([briefingResource]);
    this.setIsCanShowCreateAgent(true);
    this.setIsCreateNewBriefingFromChat(false);
    this.setShowCreateBriefing(true);
  }

  convert2ReferenceResource(document: IResourceModel, isUpdateBriefing: boolean, referenceIndex?: number) {
    const briefingResource = convertToBriefingResourceReq(
      document,
      this.$store.getters.userIdentity.id,
      this.$route.name,
      this.$store.getters['briefingStore/getSelectedBriefingPage'],
      undefined,
      this.$i18n.locale,
      this.$store.getters?.userIdentity?.lastName,
      undefined,
      isUpdateBriefing
    );
    briefingResource.search_type = document?.originParentDocDetail?.search_type;
    // @ts-ignore
    briefingResource.mediaType = document?.originParentDocDetail?.media_type;
    if (
      (briefingResource.search_type[0] === 'REPORT' && briefingResource.mediaType[0] === 'REPORT') ||
      document.originParentDocDetail.doc_type === 4
    ) {
      briefingResource.originType = 'REPORT';
    } else {
      briefingResource.originType = 'DISCOVERY';
    }
    briefingResource.parentDocId = document.docId;
    briefingResource.owner_user_key =
      typeof briefingResource.owner_user_key === 'string' ? briefingResource.owner_user_key : briefingResource.owner_user_key[0];

    if (referenceIndex) {
      briefingResource['referenceDocumentIndex'] = referenceIndex;
    } else {
      if (this.getReferenceDocuments?.length) {
        let maxReferenceDocumentIndex = this.getReferenceDocuments
          ? Math.max(...this.getReferenceDocuments?.map(item => item.referenceDocumentIndex))
          : 0 || 0;

        maxReferenceDocumentIndex =
          maxReferenceDocumentIndex > -1
            ? maxReferenceDocumentIndex
            : this.getReferenceDocuments[this.getReferenceDocuments.length - 1]?.referenceDocumentIndex || 0 || 0;

        briefingResource['referenceDocumentIndex'] = maxReferenceDocumentIndex + 1;
      } else {
        briefingResource['referenceDocumentIndex'] = 1;
      }
    }
    return briefingResource;
  }

  checkDuplicatedDelete(itemInput: any) {
    if (this.isLoading === true) {
      return true;
    }

    return itemInput && this.tempDeleteObject?.id === itemInput._id && this.tempDeleteObject?.docId === itemInput.docId;
  }

  checkToRemoveOverTimeLoadingReportCard() {
    this.handleClearCheckToRemoveOverTimeLoadingReportCardInterval();

    this.intervalCheckToRemoveOverTimeLoadingReportCard = setInterval(() => {
      if (this.resourceItems?.length > 0) {
        const tempReportList = this.resourceItems?.filter(item => item.type === 'REPORT') || [];

        if (tempReportList?.length > 0) {
          let tempRequestId = '';

          tempReportList.forEach(item => {
            if (
              item &&
              item.requestId !== undefined &&
              item.requestId !== '' &&
              (!item.docId || item.docId === '') &&
              item.isLoadingCard === true &&
              item.type === 'REPORT'
            ) {
              tempRequestId = item.requestId;
              const isOverTime = this.loadingReportCardUtil.handleRemoveLoadingReportCardByRequestIds(
                tempRequestId.concat(this.reportToastUtil.makeConcatStringByMediaType(item))
              );

              if (isOverTime === true) {
                const tempIndex = this.resourceItems.findIndex(item => item.requestId === tempRequestId);

                if (tempIndex > -1) {
                  this.resourceItems.splice(tempIndex, 1);
                }
              }
            }
          });
        }
      }
    }, TIME_CHECK_LOADING_REPORT);
  }

  handleClearCheckToRemoveOverTimeLoadingReportCardInterval() {
    if (this.intervalCheckToRemoveOverTimeLoadingReportCard) {
      clearInterval(this.intervalCheckToRemoveOverTimeLoadingReportCard);
      this.intervalCheckToRemoveOverTimeLoadingReportCard = null;
    }
  }

  handleRemoveLoadingReportData() {
    try {
      let countTimes = 0;

      if (this.intervalRemoveLoadingReportData) {
        clearInterval(this.intervalRemoveLoadingReportData);
        this.intervalRemoveLoadingReportData = null;
      }

      this.intervalRemoveLoadingReportData = setInterval(() => {
        if (this.resourceItems?.length > 0) {
          const tempList = this.resourceItems.filter(
            (item: IResourceModel) =>
              item?.type === 'REPORT' &&
              (item?.originParentDocDetail || item?.parentDocDetail) &&
              (item.isLoadingCard === undefined || item.isLoadingCard === false)
          );

          if (tempList?.length > 0) {
            if (this.reportToastUtil && typeof this.reportToastUtil.handleRemoveLoadingReportToastWithListInput === 'function') {
              this.reportToastUtil.handleRemoveLoadingReportToastWithListInput(tempList);
            }

            countTimes++;

            if (countTimes >= 10) {
              clearInterval(this.intervalRemoveLoadingReportData);
              this.intervalRemoveLoadingReportData = null;
              this.setReShowToastReport(!this.getReShowToastReport);
            }
          }
        }
      }, 100);

      setTimeout(() => {
        if (this.intervalRemoveLoadingReportData) {
          this.setReShowToastReport(!this.getReShowToastReport);
        }

        clearInterval(this.intervalRemoveLoadingReportData);
        this.intervalRemoveLoadingReportData = null;
      }, 10000);
    } catch (e) {
      clearInterval(this.intervalRemoveLoadingReportData);
      this.intervalRemoveLoadingReportData = null;
    }
  }

  handleRemoveAllDuplicatedItem() {
    if (this.resourceItems?.length > 0) {
      const docIdsList = new Set();
      const similarHashList = new Set();
      const tempList = [...this.resourceItems];
      let deleteCount = 0;

      tempList.forEach((item, index) => {
        let isDelete = false;

        if (item?.docId?.trim()?.length > 0 && !docIdsList.has(item?.docId)) {
          docIdsList.add(item.docId);

          if (
            (item?.originParentDocDetail?.similar_hash?.trim()?.length > 0 &&
              !similarHashList.has(item?.originParentDocDetail?.similar_hash)) ||
            !item?.originParentDocDetail?.similar_hash
          ) {
            similarHashList.add(item?.originParentDocDetail?.similar_hash);
          } else if (
            item?.originParentDocDetail?.similar_hash?.trim()?.length > 0 &&
            similarHashList.has(item?.originParentDocDetail?.similar_hash)
          ) {
            isDelete = true;
          }
        } else if (item?.docId?.trim()?.length > 0 && docIdsList.has(item?.docId)) {
          isDelete = true;
        } else if ((!item?.docId || item?.docId?.trim()?.length === 0) && (!item?.requestId || item?.requestId?.trim()?.length === 0)) {
          isDelete = true;
        }

        if (isDelete === true) {
          const tempIndex = index - deleteCount;
          const originItem = this.resourceItems?.[index] || undefined;
          const tempItem = tempIndex > -1 ? this.resourceItems?.[tempIndex] || undefined : undefined;

          const isOriginPassById = (originItem?.docId && item?.docId && originItem?.docId === item?.docId) || false;
          const isOriginPassBySimilarHash =
            (originItem?.originParentDocDetail?.similar_hash &&
              item?.originParentDocDetail?.similar_hash &&
              originItem?.originParentDocDetail?.similar_hash === item?.originParentDocDetail?.similar_hash) ||
            false;

          if (isOriginPassById === true || isOriginPassBySimilarHash === true) {
            // console.log('item deleted: ', item);
            this.resourceItems.splice(index, 1);
            deleteCount++;
          } else {
            const isTempPassById = (tempItem?.docId && item?.docId && tempItem?.docId === item?.docId) || false;
            const isTempPassBySimilarHash =
              (tempItem?.originParentDocDetail?.similar_hash &&
                item?.originParentDocDetail?.similar_hash &&
                tempItem?.originParentDocDetail?.similar_hash === item?.originParentDocDetail?.similar_hash) ||
              false;

            if (isTempPassById === true || isTempPassBySimilarHash === true) {
              // console.log('item deleted: ', item);
              this.resourceItems.splice(index, 1);
              deleteCount++;
            } else if ((!item?.docId || item?.docId?.trim()?.length === 0) && (!item?.requestId || item?.requestId?.trim()?.length === 0)) {
              // console.log('item deleted: ', item);
              this.resourceItems.splice(index, 1);
              deleteCount++;
            }
          }
        }
      });
    }
  }

  getChatPage(item: IResourceModel) {
    try {
      return item.other_info.chatPage;
    } catch (e) {
      // console.log(e);
      return 'Home';
    }
  }

  getLastUpdate(item: IResourceModel) {
    try {
      return item.other_info.updatedDate;
      // return formatDateAgo(moment(item.other_info.updatedDate || item.publishAt, 'YYYYMMDDHHmmss'));
    } catch (e) {
      // console.log(e);
      return formatDateAgo(moment(item.publishAt, 'YYYYMMDDHHmmss'));
    }
  }

  getReportId(item: IResourceModel) {
    try {
      return item.other_info.reportId;
    } catch (e) {
      // console.log(e);
      return '';
    }
  }

  getBriefingId(item: IResourceModel) {
    try {
      return item.other_info.briefingId;
    } catch (e) {
      // console.log(e);
      return '';
    }
  }

  copyShareLink(conversationId: any) {
    const url = `${window.location.origin}/home?conversationId=${conversationId}`;

    navigator.clipboard
      .writeText(url)
      .then(() => {
        this.showToast('Coppied to clipboard!', 'Success', 'success');
      })
      .catch(() => {
        this.showToast('Cannot coppied to clipboard.', 'Fail', 'danger');
      });
  }

  viewHistoryConversation(item: IResourceModel | any) {
    this.currentConversation = this.buildConversationInfo(item);
    this.historyOpenModal = true;
  }

  closeHistoryConversation() {
    this.historyOpenModal = false;
  }

  buildConversationInfo(item: IResourceModel): ConversationInfo {
    return {
      title: item.title,
      historyDate: item?.other_info?.historyDate || item.publishAt,
      conversationId: item.docId,
      chatPage: this.getChatPage(item),
      lastQuestion: item?.lastQuestion || item.content,
      isBookmark: item.isBookmarked || item.isBookmark,
      briefingId: item.bpId,
      briefingTitle: this.convertTitle(item),
      other_info: item.other_info,
      docId: item.docId,
    } as ConversationInfo;
  }

  getContent(item: IResourceModel) {
    try {
      if (item.content) {
        return item.content;
      } else {
        return item.other_info.lastQuestion;
      }
    } catch (e) {
      return '';
    }
  }

  convertTitle(item: IResourceModel) {
    try {
      if (item.other_info.briefingTitle) {
        return `${item?.other_info.briefingTitle}`;
      } else {
        if (item.other_info.chatPage == 'home') {
          return this.$t('my-create.common.chat-page.home');
        }
        if (item.other_info.chatPage == 'browser') {
          return this.$t('my-create.common.chat-page.browser');
        }
        return item.other_info.chatPage.replace(/\b\w/g, char => char.toUpperCase()) + ' Page';
      }
    } catch (error) {
      // console.log(error);
      return 'Home';
    }
  }

  updateBookmark(item: IResourceModel | any) {
    const model = this.buildConversationInfo(item);
    const requestId = uuidv4().toString();
    const user = this.tempUser;
    const userKey = user.id;
    const newBookmarkStatus = !model.isBookmark;
    const payload = {
      userKey: userKey,
      conversationId: model.conversationId,
      title: model.title,
      login: userKey,
      isBookmark: newBookmarkStatus,
      otherInfo: item.other_info,
    };
    const index = this.resourceItems.findIndex(item => item.docId === model.conversationId);
    if (index !== -1) {
      this.$set(this.resourceItems, index, {
        ...this.resourceItems[index],
        isBookmarked: newBookmarkStatus,
      });
    }
    this.askGooverService()
      .addBookMark(payload)
      .then(resp => {
        const index = this.resourceItems.findIndex(item => item.docId === model.conversationId);
        if (index !== -1 && !newBookmarkStatus) {
          // this.$set(this.resourceItems, index, {
          //   ...this.resourceItems[index],
          //   isBookmarked: newBookmarkStatus,
          // });
          this.resourceItems.splice(index, 1);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }

  updateBookmarkForDetail(selectedItem: IResourceModel | any) {
    const model = this.buildConversationInfo(selectedItem);
    const requestId = uuidv4().toString();
    const user = this.tempUser;
    const userKey = user.id;
    const newBookmarkStatus = !model.isBookmark;
    const payload = {
      userKey: userKey,
      conversationId: model.conversationId,
      title: model.title,
      login: userKey,
      isBookmark: newBookmarkStatus,
      otherInfo: selectedItem.other_info,
    };
    const index = this.resourceItems.findIndex(item => item.docId === selectedItem.conversationId);
    if (index !== -1) {
      this.$set(this.resourceItems, index, {
        ...this.resourceItems[index],
        isBookmarked: newBookmarkStatus,
      });
    }
    this.askGooverService()
      .addBookMark(payload)
      .then(resp => {
        const index = this.resourceItems.findIndex(item => item.docId === model.conversationId);
        if (index !== -1 && !newBookmarkStatus) {
          // this.$set(this.resourceItems, index, {
          //   ...this.resourceItems[index],
          //   isBookmarked: newBookmarkStatus,
          // });
          this.resourceItems.splice(index, 1);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
}
